import { RootState } from '@store/store'

export const getVoicesErrors = (state: RootState) => state.templates.error
export const getTemplatesLoading = (state: RootState) => state.templates.loading
